import React from 'react';

// A trial's Open / Closed as a pill - the one design everywhere it is shown (as in the trials table)
const STYLES = {
  closed: 'bg-orange-100 text-orange-900 dark:border-orange-900/75 dark:bg-orange-700/10 dark:text-orange-200',
  open: 'bg-emerald-100 text-emerald-900 dark:border-emerald-900 dark:bg-emerald-700/10 dark:text-emerald-200',
};

/**
 * Open / Closed of a trial. `closed` may be the API's 0/1 or a boolean. `openLabel` names the open state where it
 * is not a trial's (a customer is "Active").
 */
export default function TrialStatusBadge({ closed, openLabel = 'Open' }) {
  const isClosed = closed === true || closed === 1 || closed === '1';
  return (
    <span
      data-testid="trial-status-badge"
      data-closed={isClosed}
      className={`inline-flex rounded-full border border-transparent px-2 py-1 text-[11px] leading-4 font-semibold ${isClosed ? STYLES.closed : STYLES.open}`}
    >
      {isClosed ? 'Closed' : openLabel}
    </span>
  );
}
